import React from 'react';
import { v4 as uuid } from 'uuid';
import { FuelIcon, FuelTypography } from '@frete.com/fuel-react';
import { BenefitsContainer, BenefitsTitleContainer, BenefitsIconContainer, BenefitItem } from './styled';

const benefits = [
  'Acesso a perfis completos e verificados',
  'Garantia contra golpe de adiantamento',
  'Visualização do status da viagem em tempo real',
  'Avaliação completa do motorista após viagem',
];

export const TruckerInformationsBenefits: React.FC = () => (
  <BenefitsContainer>
    <BenefitsTitleContainer>
      <BenefitsIconContainer>
        <FuelIcon name="diamond" size="tiny" />
      </BenefitsIconContainer>
      <FuelTypography weight="bold" color="neutral-strong" size="body-md">
        Convide o motorista e usufrua dos nossos benefícios:
      </FuelTypography>
    </BenefitsTitleContainer>
    {benefits.map((item) => (
      <BenefitItem key={uuid()}>
        <FuelIcon iconStyle="filled" name="one-check" size="micro" />
        <FuelTypography weight="medium" color="neutral-default" size="body-sm">
          {item}
        </FuelTypography>
      </BenefitItem>
    ))}
  </BenefitsContainer>
);
